import { useFetch } from '@/hooks/useFetch';
import type { ErrorResponse } from '@/types/apiTypes';
import { useMutation } from '@tanstack/react-query';

export const usePublishClientMutation = () => {
  const { doFetch: publishClient } = useFetch<void, void>();

  return useMutation<void, ErrorResponse<unknown>, number>({
    mutationFn: (clientId: number) =>
      publishClient(`/api/clients/flag/publish/${clientId}`, {
        method: 'PATCH',
      }),
  });
};
